<template>
 <div class="erro-atendimento">
  <v-alert prominent outlined type="error" :value="true" text icon>
   {{ message }}
  </v-alert>
 </div>
</template>
<script>
export default {
 props: {
  message: {
   default: 'Ocorreu um problema ao realizar o seu atendimento'
  }
 }
}
</script>
<style scoped>
.erro-atendimento {
 display: flex;
 flex-direction: column;
 justify-content: center;
 align-items: center;
 height: 100%;
}
</style>